import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { DialogueHandler, LogoutDialogueHandler } from './types';
import LogoutDialogueContext from './LogoutContext';
import { useTranslation } from 'react-i18next';

const { ConfirmationDialogue } = vp;

type LogoutDialogueProps = {
  handleDialogue: DialogueHandler<LogoutDialogueHandler>;
};

type FC = FunctionComponent<LogoutDialogueProps>;

const LogoutDialogue: FC = ({ handleDialogue }: LogoutDialogueProps) => {
  const { showLogoutAlert, isSuspiciousLogin } = useContext(LogoutDialogueContext);
  const { t } = useTranslation('translations', { keyPrefix: 'Login.LogoutDialog' });

  const Title = isSuspiciousLogin ? t('SuspiciousLogin.title') : t('title');

  const SubTitle = isSuspiciousLogin ? t('SuspiciousLogin.subTitle') : t('subTitle');

  return useMemo(
    () => (
      <div>
        <ConfirmationDialogue
          isVisible={showLogoutAlert}
          title={Title}
          status="error"
          subTitle={SubTitle}
          confirm={{
            label: t('closeButton'),
            action: () => handleDialogue({ type: 'error', state: 'confirm' }),
          }}
        />
      </div>
    ),
    [showLogoutAlert],
  );
};

export default LogoutDialogue;
